import { NumberFormatProps } from "components/NumberFormat/types";
import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { evaluate } from "mathjs";
import useCoreStore from "views/hooks/useCoreStore";

export default function NumberFormatCurrency(props: NumberFormatProps): React.ReactElement {
  const { onChange, onBlur, value, ...rest } = props;
  const currency = useCoreStore(state => state.currency);
  const decimalPlaces = currency?.decimalPlaces;

  const regexCheckNumberOrOperator =
    /^((\d{1,})?(\.)?(\d{1,})?([-+*/])?(\d{1,})?(\.)?(\d{1,})?)+$/g;
  const regexCheckNumberOrCalculation =
    /(?:(?:^|[-+_*/])(?:\s*-?\d+(\.\d+)?(?:[eE][+-]?\d+)?\s*))+$/;
  const [displayValue, setDisplayValue] = useState<string>();

  useEffect(() => {
    if (!isNaN(Number(value)) && value !== displayValue) {
      setDisplayValue(Number(value).toFixed(decimalPlaces));
    }
  }, [value]);

  const isNumber = !isNaN(Number(value)) && Number(value) !== Infinity;
  const newValue = isNumber
    ? Number(value).toFixed(decimalPlaces)
    : "0." + "0".repeat(decimalPlaces ?? 0);

  return (
    <Input
      data-hj-allow
      className="text-align-right"
      maxLength={15}
      onFocus={e => {
        e.target.select();
      }}
      onChange={e => {
        const value = e.target.value;
        if (value.match(regexCheckNumberOrOperator)) {
          onChange?.(value);
          setDisplayValue(value);
        }
      }}
      onBlur={e => {
        onBlur?.(e);
        let value = e.target.value;
        const positiveOrNegative =
          Number(value) > 0
            ? Math.abs(Number(value)).toFixed(decimalPlaces)
            : -Math.abs(Number(value)).toFixed(decimalPlaces);

        if (regexCheckNumberOrCalculation.test(value)) {
          value = evaluate(value);
        } else {
          value = "";
        }
        const isNumber = !isNaN(Number(value)) && Number(value) !== Infinity;

        onChange?.(isNumber ? positiveOrNegative : "");
        setDisplayValue(value && isNumber ? String(positiveOrNegative) : "");
      }}
      value={displayValue || newValue}
      {...rest}
    />
  );
}
